import {Component, inject, input, output} from '@angular/core';
import {ImagesService} from '../../../services/general/images.service';
import {FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {PrimaryButtonComponent} from "../../buttons/primary-button/primary-button.component";
import {InstitutionService} from '../../../services/institution/institution.service';
import {Institution} from '../../../interfaces/responses/institution.interface';
import {ToastService} from '../../../services/general/toast.service';

@Component({
  selector: 'app-add-members',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PrimaryButtonComponent
],
  templateUrl: './add-members.component.html',
  styleUrl: './add-members.component.scss'
})
export class AddMembersComponent {
  _images = inject(ImagesService)
  _fb = inject(FormBuilder)
  csvFile: File | null = null
  isLoading: boolean = false;
  institutionService = inject(InstitutionService)
  institution = input<Institution | null>(null);
  _toast = inject(ToastService)

  onCloseEvent = output<boolean>()
  onClose() {
    this.onCloseEvent.emit(false);
  }

  downloadSampleCSV() {
    fetch('/sample.xlsx')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch sample file');
        }
        return response.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'sample.xlsx';
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Error downloading sample file:', error);
        this._toast.error('Failed to download sample file');
      });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.csvFile = input.files[0];
    }
  }

  getFileSize(): string {
    if (!this.csvFile) return '0 KB';
    const sizeInKB = this.csvFile.size / 1024;
    if (sizeInKB < 1024) {
      return sizeInKB.toFixed(2) + ' KB';
    }
    return (sizeInKB / 1024).toFixed(2) + ' MB';
  }

  onSubmit() {
    const institutionId = this.institution()?.id;

    if(!institutionId) {
      console.error('No institution ID found');
      return;
    }

    const formData = new FormData();
    if (this.csvFile) {
      formData.append('institutionId', institutionId ?? '');
      formData.append('member_list', this.csvFile, this.csvFile.name);
    } else {
      console.error('No CSV file selected');
      return;
    }

    this.isLoading = true;

    this.institutionService.postInstitutionMembers(formData).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.onClose();
        this.csvFile = null;
        this._toast.success(response?.message || 'Members added successfully');
      },
      error: (error) => {
        console.error('Upload failed:', error);
        const message = error?.error?.message || error?.error?.response_message || 'Failed to add members';
        this._toast.error(message);
        this.isLoading = false;
      }
    });
  }

}
